import { render, staticRenderFns } from "./TypeMaintenance.vue?vue&type=template&id=2b9b2456&"
import script from "./TypeMaintenance.vue?vue&type=script&lang=js&"
export * from "./TypeMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports